/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConfigSettingsOut } from '../models';
// @ts-ignore
import type { ConfigSettingsUpdate } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { LineKeywordOut } from '../models';
// @ts-ignore
import type { LineSettingsOut } from '../models';
// @ts-ignore
import type { LivechatSettingsOut } from '../models';
// @ts-ignore
import type { TawktoSettingsOut } from '../models';
// @ts-ignore
import type { WhatsappKeywordOut } from '../models';
// @ts-ignore
import type { WhatsappSettingsOut } from '../models';
// @ts-ignore
import type { ZaloSettingsOut } from '../models';
/**
 * ConfigSettingsApi - axios parameter creator
 * @export
 */
export const ConfigSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * DANGEROUS OPERATION: Deletes ALL keys in the selected Redis database (DB 0). Use with extreme caution.
         * @summary Clear All Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAllCache: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/clear-all-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings. If no settings are found, a mocked default object will be returned.
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineConfig: async (agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/line`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns AISEStopKeyword and AISEStartKeyword from config settings.
         * @summary Get Line AISE keywords
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineKeywords: async (agentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/line-keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Livechat.
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLivechatConfig: async (agentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/livechat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Tawk.to.
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTawktoConfig: async (agentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/tawkto`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Whatsapp.
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatsappConfig: async (agentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/whatsapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns AISEStopKeyword and AISEStartKeyword from config settings.
         * @summary Get WhatsApp AISE keywords
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatsappKeywords: async (agentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/whatsapp-keywords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get WhatsApp QR code image if exists (used for bot login)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatsappQr: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/whatsapp-qr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Zalo.
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZaloConfig: async (agentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config-settings/zalo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates configuration settings for an organization per Channel. If no configuration exists for the Channel, a new record will be created.
         * @param {ConfigSettingsUpdate} configSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfig: async (configSettingsUpdate: ConfigSettingsUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configSettingsUpdate' is not null or undefined
            assertParamExists('updateConfig', 'configSettingsUpdate', configSettingsUpdate)
            const localVarPath = `/api/v1/config-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configSettingsUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigSettingsApi - functional programming interface
 * @export
 */
export const ConfigSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * DANGEROUS OPERATION: Deletes ALL keys in the selected Redis database (DB 0). Use with extreme caution.
         * @summary Clear All Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearAllCache(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearAllCache(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.clearAllCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings. If no settings are found, a mocked default object will be returned.
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLineConfig(agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineSettingsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLineConfig(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.getLineConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns AISEStopKeyword and AISEStartKeyword from config settings.
         * @summary Get Line AISE keywords
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLineKeywords(agentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineKeywordOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLineKeywords(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.getLineKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Livechat.
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLivechatConfig(agentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LivechatSettingsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLivechatConfig(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.getLivechatConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Tawk.to.
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTawktoConfig(agentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TawktoSettingsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTawktoConfig(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.getTawktoConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Whatsapp.
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhatsappConfig(agentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhatsappSettingsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhatsappConfig(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.getWhatsappConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns AISEStopKeyword and AISEStartKeyword from config settings.
         * @summary Get WhatsApp AISE keywords
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhatsappKeywords(agentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhatsappKeywordOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhatsappKeywords(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.getWhatsappKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get WhatsApp QR code image if exists (used for bot login)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhatsappQr(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhatsappQr(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.getWhatsappQr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Zalo.
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZaloConfig(agentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZaloSettingsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZaloConfig(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.getZaloConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates configuration settings for an organization per Channel. If no configuration exists for the Channel, a new record will be created.
         * @param {ConfigSettingsUpdate} configSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfig(configSettingsUpdate: ConfigSettingsUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigSettingsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfig(configSettingsUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigSettingsApi.updateConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConfigSettingsApi - factory interface
 * @export
 */
export const ConfigSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigSettingsApiFp(configuration)
    return {
        /**
         * DANGEROUS OPERATION: Deletes ALL keys in the selected Redis database (DB 0). Use with extreme caution.
         * @summary Clear All Cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAllCache(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.clearAllCache(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings. If no settings are found, a mocked default object will be returned.
         * @param {ConfigSettingsApiGetLineConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineConfig(requestParameters: ConfigSettingsApiGetLineConfigRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LineSettingsOut> {
            return localVarFp.getLineConfig(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns AISEStopKeyword and AISEStartKeyword from config settings.
         * @summary Get Line AISE keywords
         * @param {ConfigSettingsApiGetLineKeywordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLineKeywords(requestParameters: ConfigSettingsApiGetLineKeywordsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LineKeywordOut> {
            return localVarFp.getLineKeywords(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Livechat.
         * @param {ConfigSettingsApiGetLivechatConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLivechatConfig(requestParameters: ConfigSettingsApiGetLivechatConfigRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LivechatSettingsOut> {
            return localVarFp.getLivechatConfig(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Tawk.to.
         * @param {ConfigSettingsApiGetTawktoConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTawktoConfig(requestParameters: ConfigSettingsApiGetTawktoConfigRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TawktoSettingsOut> {
            return localVarFp.getTawktoConfig(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Whatsapp.
         * @param {ConfigSettingsApiGetWhatsappConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatsappConfig(requestParameters: ConfigSettingsApiGetWhatsappConfigRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WhatsappSettingsOut> {
            return localVarFp.getWhatsappConfig(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns AISEStopKeyword and AISEStartKeyword from config settings.
         * @summary Get WhatsApp AISE keywords
         * @param {ConfigSettingsApiGetWhatsappKeywordsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatsappKeywords(requestParameters: ConfigSettingsApiGetWhatsappKeywordsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WhatsappKeywordOut> {
            return localVarFp.getWhatsappKeywords(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get WhatsApp QR code image if exists (used for bot login)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhatsappQr(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getWhatsappQr(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve the current system configuration settings for Zalo.
         * @param {ConfigSettingsApiGetZaloConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZaloConfig(requestParameters: ConfigSettingsApiGetZaloConfigRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ZaloSettingsOut> {
            return localVarFp.getZaloConfig(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates configuration settings for an organization per Channel. If no configuration exists for the Channel, a new record will be created.
         * @param {ConfigSettingsApiUpdateConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfig(requestParameters: ConfigSettingsApiUpdateConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConfigSettingsOut> {
            return localVarFp.updateConfig(requestParameters.configSettingsUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getLineConfig operation in ConfigSettingsApi.
 * @export
 * @interface ConfigSettingsApiGetLineConfigRequest
 */
export interface ConfigSettingsApiGetLineConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigSettingsApiGetLineConfig
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for getLineKeywords operation in ConfigSettingsApi.
 * @export
 * @interface ConfigSettingsApiGetLineKeywordsRequest
 */
export interface ConfigSettingsApiGetLineKeywordsRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigSettingsApiGetLineKeywords
     */
    readonly agentId?: string
}

/**
 * Request parameters for getLivechatConfig operation in ConfigSettingsApi.
 * @export
 * @interface ConfigSettingsApiGetLivechatConfigRequest
 */
export interface ConfigSettingsApiGetLivechatConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigSettingsApiGetLivechatConfig
     */
    readonly agentId?: string
}

/**
 * Request parameters for getTawktoConfig operation in ConfigSettingsApi.
 * @export
 * @interface ConfigSettingsApiGetTawktoConfigRequest
 */
export interface ConfigSettingsApiGetTawktoConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigSettingsApiGetTawktoConfig
     */
    readonly agentId?: string
}

/**
 * Request parameters for getWhatsappConfig operation in ConfigSettingsApi.
 * @export
 * @interface ConfigSettingsApiGetWhatsappConfigRequest
 */
export interface ConfigSettingsApiGetWhatsappConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigSettingsApiGetWhatsappConfig
     */
    readonly agentId?: string
}

/**
 * Request parameters for getWhatsappKeywords operation in ConfigSettingsApi.
 * @export
 * @interface ConfigSettingsApiGetWhatsappKeywordsRequest
 */
export interface ConfigSettingsApiGetWhatsappKeywordsRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigSettingsApiGetWhatsappKeywords
     */
    readonly agentId?: string
}

/**
 * Request parameters for getZaloConfig operation in ConfigSettingsApi.
 * @export
 * @interface ConfigSettingsApiGetZaloConfigRequest
 */
export interface ConfigSettingsApiGetZaloConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigSettingsApiGetZaloConfig
     */
    readonly agentId?: string
}

/**
 * Request parameters for updateConfig operation in ConfigSettingsApi.
 * @export
 * @interface ConfigSettingsApiUpdateConfigRequest
 */
export interface ConfigSettingsApiUpdateConfigRequest {
    /**
     * 
     * @type {ConfigSettingsUpdate}
     * @memberof ConfigSettingsApiUpdateConfig
     */
    readonly configSettingsUpdate: ConfigSettingsUpdate
}

/**
 * ConfigSettingsApi - object-oriented interface
 * @export
 * @class ConfigSettingsApi
 * @extends {BaseAPI}
 */
export class ConfigSettingsApi extends BaseAPI {
    /**
     * DANGEROUS OPERATION: Deletes ALL keys in the selected Redis database (DB 0). Use with extreme caution.
     * @summary Clear All Cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public clearAllCache(options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).clearAllCache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current system configuration settings. If no settings are found, a mocked default object will be returned.
     * @param {ConfigSettingsApiGetLineConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public getLineConfig(requestParameters: ConfigSettingsApiGetLineConfigRequest = {}, options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).getLineConfig(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns AISEStopKeyword and AISEStartKeyword from config settings.
     * @summary Get Line AISE keywords
     * @param {ConfigSettingsApiGetLineKeywordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public getLineKeywords(requestParameters: ConfigSettingsApiGetLineKeywordsRequest = {}, options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).getLineKeywords(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current system configuration settings for Livechat.
     * @param {ConfigSettingsApiGetLivechatConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public getLivechatConfig(requestParameters: ConfigSettingsApiGetLivechatConfigRequest = {}, options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).getLivechatConfig(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current system configuration settings for Tawk.to.
     * @param {ConfigSettingsApiGetTawktoConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public getTawktoConfig(requestParameters: ConfigSettingsApiGetTawktoConfigRequest = {}, options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).getTawktoConfig(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current system configuration settings for Whatsapp.
     * @param {ConfigSettingsApiGetWhatsappConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public getWhatsappConfig(requestParameters: ConfigSettingsApiGetWhatsappConfigRequest = {}, options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).getWhatsappConfig(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns AISEStopKeyword and AISEStartKeyword from config settings.
     * @summary Get WhatsApp AISE keywords
     * @param {ConfigSettingsApiGetWhatsappKeywordsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public getWhatsappKeywords(requestParameters: ConfigSettingsApiGetWhatsappKeywordsRequest = {}, options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).getWhatsappKeywords(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get WhatsApp QR code image if exists (used for bot login)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public getWhatsappQr(options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).getWhatsappQr(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve the current system configuration settings for Zalo.
     * @param {ConfigSettingsApiGetZaloConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public getZaloConfig(requestParameters: ConfigSettingsApiGetZaloConfigRequest = {}, options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).getZaloConfig(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates configuration settings for an organization per Channel. If no configuration exists for the Channel, a new record will be created.
     * @param {ConfigSettingsApiUpdateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigSettingsApi
     */
    public updateConfig(requestParameters: ConfigSettingsApiUpdateConfigRequest, options?: RawAxiosRequestConfig) {
        return ConfigSettingsApiFp(this.configuration).updateConfig(requestParameters.configSettingsUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

